import { msg } from '@lingui/core/macro';

export const mustHaveEmployee = msg`You must have an employee record in Intacct to create a timesheet.`;
export const noEditPermissions = msg`You do not have permissions to edit timesheets in Intacct.`;

export const mustHaveEditStaffPermissions = msg`You must have permissions to edit staff timesheets in Intacct.`;
export const mustHaveCreateStaffPermissions = msg`You must have permissions to create staff timesheets in Intacct.`;
